(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-bath-zero"]) return;
  try {
    
function bathShippingState(now){
 const zone=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 const localStamp=date=>{const p=Object.fromEntries(zone.formatToParts(date).filter(x=>x.type!=='literal').map(x=>[x.type,Number(x.value)]));return Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);};
 const local=localStamp(now),localDate=new Date(local),weekday=localDate.getUTCDay();
 const today=weekday>=1&&weekday<=5&&localDate.getUTCHours()<13;
 let target=new Date(local);target.setUTCHours(13,0,0,0);
 if(!today){target.setUTCDate(target.getUTCDate()+1);while(target.getUTCDay()===0||target.getUTCDay()===6)target.setUTCDate(target.getUTCDate()+1);}
 let deadline=target.getTime();for(let i=0;i<3;i++)deadline+=target.getTime()-localStamp(new Date(deadline));
 const delivery=new Date(target);delivery.setUTCDate(delivery.getUTCDate()+1);while(delivery.getUTCDay()===0||delivery.getUTCDay()===6)delivery.setUTCDate(delivery.getUTCDate()+1);
 const days=['niedzielę','poniedziałek','wtorek','środę','czwartek','piątek','sobotę'];
 return {delivery:'Dostawa '+(delivery.getUTCDay()===2?'we ':'w ')+days[delivery.getUTCDay()],showTimer:today,seconds:Math.max(0,Math.ceil((deadline-now.getTime())/1000)),title:today?'Wysyłka jeszcze dziś':(Date.UTC(target.getUTCFullYear(),target.getUTCMonth(),target.getUTCDate())-Date.UTC(localDate.getUTCFullYear(),localDate.getUTCMonth(),localDate.getUTCDate())===86400000?'Wysyłka jutro':'Wysyłka '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]),label:today?'Zamów w ciągu:':'Zamów do 13:00 '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]+':'};
}

function initBathPage(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const shipping=root.querySelector('[data-zp-shipping]');
 if(shipping){
  const tick=()=>{const state=bathShippingState(new Date()),remaining=state.seconds;
   root.querySelector('[data-zp-dispatch-title]').textContent=state.title;
   root.querySelector('[data-zp-delivery-day]').textContent=state.delivery;
   root.querySelector('[data-zp-shipping-label]').textContent=state.label;
   root.querySelector('[data-zp-countdown]').textContent=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60].map(value=>String(value).padStart(2,'0')).join(':');
   shipping.hidden=!state.showTimer;
  };
  tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
 }
 root.querySelectorAll('[data-zp-quantity]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('input[name=quantity]');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(button.dataset.zpQuantity));}));
 const variant=root.querySelector('[data-zp-variant]');variant?.addEventListener('change',()=>{const option=variant.selectedOptions[0],available=option.dataset.available==='true';root.querySelector('[data-zp-price]').textContent=option.dataset.price;root.querySelector('[data-zp-add]').disabled=!available;root.querySelector('[data-zp-add-label]').textContent=available?'Dodaj do koszyka':'Wyprzedane';root.querySelector('[data-zp-stock]').textContent=available?'Dostępny':'Chwilowo niedostępny';});

}
document.querySelectorAll('[data-bath-product]').forEach(initBathPage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-bath-product]').forEach(initBathPage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-books-collection"] && !Shopify.designMode) return;
  try {
    
function initSC(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const cards=[...root.querySelectorAll('[data-sc-product]')],search=root.querySelector('[data-sc-search]');let onlyAvailable=false;
 if(!search)return;
 const normalize=value=>value.toLocaleLowerCase('pl').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ł/g,'l');
 const update=()=>{let visible=0;const query=normalize(search.value.trim());cards.forEach(card=>{card.hidden=(onlyAvailable&&card.dataset.scAvailable!=='true')||!normalize(card.dataset.scTitle).includes(query);if(!card.hidden)visible++;});root.querySelector('[data-sc-empty]').hidden=visible!==0||cards.length===0;root.querySelector('[data-sc-count]').textContent=cards.length?'Widoczne: '+visible+' / '+cards.length:'';};
 root.querySelectorAll('[data-sc-filter]').forEach(button=>button.addEventListener('click',()=>{onlyAvailable=button.dataset.scFilter==='available';root.querySelectorAll('[data-sc-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));update();}));
 search.addEventListener('input',update);update();
}
document.querySelectorAll('[data-sc-collection]').forEach(initSC);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sc-collection]').forEach(initSC));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-candle-zero"]) return;
  try {
    

function initCandleVideo(root){
 const video=root.querySelector('.zp-film-media video');
 if(!video)return;
 const frame=video.closest('.zp-video-frame'),reduce=window.matchMedia('(prefers-reduced-motion: reduce)'),events=new AbortController();
 let visible=false;
 video.muted=true;video.playsInline=true;
 const fit=()=>{if(frame&&video.videoWidth&&video.videoHeight)frame.style.setProperty('--zp-video-ratio',video.videoWidth/video.videoHeight);};
 video.addEventListener('loadedmetadata',fit,{signal:events.signal});fit();
 const play=()=>{if(visible&&!document.hidden&&!reduce.matches){const pending=video.play();if(pending)pending.catch(()=>{});}else video.pause();};
 if(!('IntersectionObserver' in window))return;
 const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.35;play();},{threshold:[0,.35]});
 observer.observe(video);
 document.addEventListener('visibilitychange',play,{signal:events.signal});
 reduce.addEventListener('change',play,{signal:events.signal});
 document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){observer.disconnect();events.abort();video.pause();}},{signal:events.signal});
}


function initCandleGallery(root){
 const slides=[...root.querySelectorAll('[data-zp-slide]')],thumbs=[...root.querySelectorAll('[data-zp-thumb]')],dialog=root.querySelector('.zp-dialog'),full=root.querySelector('[data-zp-full]'),stage=root.querySelector('[data-zp-swipe]');
 if(!slides.length||!dialog||!full||!stage)return;
 let active=0,lastSwipe=-1000;
 const count=()=>String(active+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
 const updateFull=()=>{const photo=slides[active].querySelector('img');full.src=slides[active].querySelector('[data-zp-zoom]').dataset.zpFullSrc||photo.currentSrc||photo.src;full.alt=photo.alt;root.querySelector('[data-zp-full-count]').textContent=count();};
 const select=index=>{
  active=(index+slides.length)%slides.length;
  slides.forEach((slide,i)=>{slide.hidden=i!==active;});
  thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===active)));
  root.querySelector('[data-zp-gallery-count]').textContent=count();
  const thumb=thumbs[active],strip=thumb?.parentElement;
  if(thumb&&strip)strip.scrollTo({left:thumb.offsetLeft-strip.offsetLeft-(strip.clientWidth-thumb.clientWidth)/2,behavior:'auto'});
  if(dialog.open)updateFull();
 };
 const step=delta=>select(active+delta);
 thumbs.forEach((button,index)=>button.addEventListener('click',()=>select(index)));
 root.querySelectorAll('[data-zp-step],[data-zp-full-step]').forEach(button=>{button.hidden=slides.length<2;button.addEventListener('click',()=>step(Number(button.dataset.zpStep||button.dataset.zpFullStep)));});
 const keys=event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();step(event.key==='ArrowLeft'?-1:1);}};
 stage.addEventListener('keydown',keys);dialog.addEventListener('keydown',keys);
 root.querySelectorAll('[data-zp-zoom]').forEach((button,index)=>button.addEventListener('click',()=>{if(performance.now()-lastSwipe<400)return;select(index);updateFull();dialog.showModal();}));
 const swipe=area=>{let start=null;
  area.addEventListener('pointerdown',event=>{if(event.isPrimary&&event.button===0)start={x:event.clientX,y:event.clientY};});
  area.addEventListener('pointercancel',()=>{start=null;});
  area.addEventListener('pointerup',event=>{if(!start)return;const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3){lastSwipe=performance.now();step(dx<0?1:-1);}});
  area.addEventListener('dragstart',event=>event.preventDefault());
 };
 swipe(stage);swipe(root.querySelector('[data-zp-full-swipe]'));
 root.querySelector('[data-zp-close]').addEventListener('click',()=>dialog.close());
 select(0);
}

function candleShippingState(now){
 const zone=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 const localStamp=date=>{const p=Object.fromEntries(zone.formatToParts(date).filter(x=>x.type!=='literal').map(x=>[x.type,Number(x.value)]));return Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);};
 const local=localStamp(now),localDate=new Date(local),weekday=localDate.getUTCDay();
 const today=weekday>=1&&weekday<=5&&localDate.getUTCHours()<13;
 let target=new Date(local);target.setUTCHours(13,0,0,0);
 if(!today){target.setUTCDate(target.getUTCDate()+1);while(target.getUTCDay()===0||target.getUTCDay()===6)target.setUTCDate(target.getUTCDate()+1);}
 let deadline=target.getTime();for(let i=0;i<3;i++)deadline+=target.getTime()-localStamp(new Date(deadline));
 const delivery=new Date(target);delivery.setUTCDate(delivery.getUTCDate()+1);while(delivery.getUTCDay()===0)delivery.setUTCDate(delivery.getUTCDate()+1);
 const days=['niedzielę','poniedziałek','wtorek','środę','czwartek','piątek','sobotę'];
 return {delivery:'Dostawa '+(delivery.getUTCDay()===2?'we ':'w ')+days[delivery.getUTCDay()],showTimer:today,seconds:Math.max(0,Math.ceil((deadline-now.getTime())/1000)),title:today?'Wysyłka jeszcze dziś':(Date.UTC(target.getUTCFullYear(),target.getUTCMonth(),target.getUTCDate())-Date.UTC(localDate.getUTCFullYear(),localDate.getUTCMonth(),localDate.getUTCDate())===86400000?'Wysyłka jutro':'Wysyłka '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]),label:today?'Zamów w ciągu:':'Zamów do 13:00 '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]+':'};
}

function initCandlePage(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const shipping=root.querySelector('[data-zp-shipping]');
 if(shipping){
  const tick=()=>{const state=candleShippingState(new Date()),remaining=state.seconds;
   root.querySelector('[data-zp-dispatch-title]').textContent=state.title;
   root.querySelector('[data-zp-delivery-day]').textContent=state.delivery;
   root.querySelector('[data-zp-shipping-label]').textContent=state.label;
   root.querySelector('[data-zp-countdown]').textContent=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60].map(value=>String(value).padStart(2,'0')).join(':');
   shipping.hidden=!state.showTimer;
  };
  tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
 }
 initCandleGallery(root);
 initCandleVideo(root);
 root.querySelectorAll('[data-zp-quantity]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('input[name=quantity]');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(button.dataset.zpQuantity));}));
 const variant=root.querySelector('[data-zp-variant]');variant?.addEventListener('change',()=>{const option=variant.selectedOptions[0],available=option.dataset.available==='true';root.querySelector('[data-zp-price]').textContent=option.dataset.price;root.querySelector('[data-zp-add]').disabled=!available;root.querySelector('[data-zp-add-label]').textContent=available?'Dodaj do koszyka':'Wyprzedane';});

}
document.querySelectorAll('[data-candle-product]').forEach(initCandlePage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-candle-product]').forEach(initCandlePage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-chemik-zero"]) return;
  try {
    
function chemikShippingState(now){
 const zone=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 const localStamp=date=>{const p=Object.fromEntries(zone.formatToParts(date).filter(x=>x.type!=='literal').map(x=>[x.type,Number(x.value)]));return Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);};
 const local=localStamp(now),localDate=new Date(local),weekday=localDate.getUTCDay();
 const today=weekday>=1&&weekday<=5&&localDate.getUTCHours()<13;
 let target=new Date(local);target.setUTCHours(13,0,0,0);
 if(!today){target.setUTCDate(target.getUTCDate()+1);while(target.getUTCDay()===0||target.getUTCDay()===6)target.setUTCDate(target.getUTCDate()+1);}
 let deadline=target.getTime();for(let i=0;i<3;i++)deadline+=target.getTime()-localStamp(new Date(deadline));
 const delivery=new Date(target);delivery.setUTCDate(delivery.getUTCDate()+1);while(delivery.getUTCDay()===0||delivery.getUTCDay()===6)delivery.setUTCDate(delivery.getUTCDate()+1);
 const days=['niedzielę','poniedziałek','wtorek','środę','czwartek','piątek','sobotę'];
 return {delivery:'Dostawa '+(delivery.getUTCDay()===2?'we ':'w ')+days[delivery.getUTCDay()],showTimer:today,seconds:Math.max(0,Math.ceil((deadline-now.getTime())/1000)),title:today?'Wysyłka jeszcze dziś':(Date.UTC(target.getUTCFullYear(),target.getUTCMonth(),target.getUTCDate())-Date.UTC(localDate.getUTCFullYear(),localDate.getUTCMonth(),localDate.getUTCDate())===86400000?'Wysyłka jutro':'Wysyłka '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]),label:today?'Zamów w ciągu:':'Zamów do 13:00 '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]+':'};
}

function initChemikPage(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const shipping=root.querySelector('[data-zp-shipping]');
 if(shipping){
  const tick=()=>{const state=chemikShippingState(new Date()),remaining=state.seconds;
   root.querySelector('[data-zp-dispatch-title]').textContent=state.title;
   root.querySelector('[data-zp-delivery-day]').textContent=state.delivery;
   root.querySelector('[data-zp-shipping-label]').textContent=state.label;
   root.querySelector('[data-zp-countdown]').textContent=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60].map(value=>String(value).padStart(2,'0')).join(':');
   shipping.hidden=!state.showTimer;
  };
  tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
 }
 root.querySelectorAll('[data-zp-quantity]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('input[name=quantity]');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(button.dataset.zpQuantity));}));
 const variant=root.querySelector('[data-zp-variant]');variant?.addEventListener('change',()=>{const option=variant.selectedOptions[0],available=option.dataset.available==='true';root.querySelector('[data-zp-price]').textContent=option.dataset.price;root.querySelector('[data-zp-add]').disabled=!available;root.querySelector('[data-zp-add-label]').textContent=available?'Dodaj do koszyka':'Wyprzedane';root.querySelector('[data-zp-stock]').textContent=available?'Dostępny':'Chwilowo niedostępny';});

}
document.querySelectorAll('[data-chemik-product]').forEach(initChemikPage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-chemik-product]').forEach(initChemikPage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-creative-collection"] && !Shopify.designMode) return;
  try {
    
function initDIYCollection(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const cards=[...root.querySelectorAll('[data-sc-product]')],search=root.querySelector('[data-sc-search]');let onlyAvailable=false;
 const normalize=value=>value.toLocaleLowerCase('pl').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ł/g,'l');
 const update=()=>{let visible=0;const query=normalize(search.value.trim());cards.forEach(card=>{card.hidden=(onlyAvailable&&card.dataset.scAvailable!=='true')||!normalize(card.dataset.scTitle).includes(query);if(!card.hidden)visible++;});root.querySelector('[data-sc-empty]').hidden=visible!==0||cards.length===0;root.querySelector('[data-sc-count]').textContent=cards.length?'Widoczne: '+visible+' / '+cards.length:'';};
 root.querySelectorAll('[data-sc-filter]').forEach(button=>button.addEventListener('click',()=>{onlyAvailable=button.dataset.scFilter==='available';root.querySelectorAll('[data-sc-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));update();}));
 search.addEventListener('input',update);update();
}
document.querySelectorAll('[data-diy-collection]').forEach(initDIYCollection);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-diy-collection]').forEach(initDIYCollection));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-footer-brand"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-rc-footer-language]') && event.target.form) {
    event.target.form.requestSubmit();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-glow-inside"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rc-glow-slideshow')){
 customElements.define('rc-glow-slideshow',class extends HTMLElement{
 connectedCallback(){
  this.track=this.querySelector('.rc-inside-slides');this.slides=[...this.querySelectorAll('.rc-inside-slide')];this.index=0;
  if(this.slides.length<2)return;
  this.controls=this.querySelector('.rc-inside-controls');this.controls.hidden=false;this.controls.replaceChildren();this.hover=false;this.focused=false;
  this.dots=this.slides.map((slide,i)=>{const dot=document.createElement('button');dot.type='button';dot.className='rc-inside-dot';dot.setAttribute('aria-label','Zdjęcie '+(i+1)+' z '+this.slides.length);this.controls.append(dot);return dot});
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');
  this.running=this.dataset.autoplay==='true'&&!this.motion.matches;
  this.abort=new AbortController();const opts={signal:this.abort.signal};
  this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.go(i-this.index),opts));
  this.track.addEventListener('scroll',()=>{clearTimeout(this.scrollTimer);this.scrollTimer=setTimeout(()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.update();this.schedule()},120)},opts);
  this.addEventListener('pointerenter',()=>{this.hover=true;this.schedule()},opts);
  this.addEventListener('pointerleave',()=>{this.hover=false;this.schedule()},opts);
  this.addEventListener('pointerdown',()=>clearTimeout(this.timer),opts);
  this.addEventListener('pointerup',()=>this.schedule(),opts);
  this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},opts);
  this.addEventListener('focusout',()=>{this.focused=false;this.schedule()},opts);
  this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(e.key==='ArrowRight'?1:-1)}},opts);
  document.addEventListener('visibilitychange',()=>this.schedule(),opts);
  this.update();this.schedule();
 }
 go(delta){this.index=(this.index+delta+this.slides.length)%this.slides.length;this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:this.motion.matches?'instant':'smooth'});this.update();this.schedule()}
 update(){this.dots.forEach((dot,i)=>{dot.setAttribute('aria-current',i===this.index?'true':'false');dot.setAttribute('aria-pressed',String(i===this.index))})}
 schedule(){clearTimeout(this.timer);if(this.running&&!this.hover&&!this.focused&&!document.hidden)this.timer=setTimeout(()=>this.go(1),Number(this.dataset.interval)||5000)}
 disconnectedCallback(){clearTimeout(this.timer);clearTimeout(this.scrollTimer);this.abort?.abort()}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-glow-zero"]) return;
  try {
    
function zpShippingState(now){
 const zone=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 const localStamp=date=>{const p=Object.fromEntries(zone.formatToParts(date).filter(x=>x.type!=='literal').map(x=>[x.type,Number(x.value)]));return Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);};
 const local=localStamp(now),localDate=new Date(local),weekday=localDate.getUTCDay();
 const today=weekday>=1&&weekday<=5&&localDate.getUTCHours()<13;
 let target=new Date(local);target.setUTCHours(13,0,0,0);
 if(!today){target.setUTCDate(target.getUTCDate()+1);while(target.getUTCDay()===0||target.getUTCDay()===6)target.setUTCDate(target.getUTCDate()+1);}
 let deadline=target.getTime();for(let i=0;i<3;i++)deadline+=target.getTime()-localStamp(new Date(deadline));
 const delivery=new Date(target);delivery.setUTCDate(delivery.getUTCDate()+1);while(delivery.getUTCDay()===0||delivery.getUTCDay()===6)delivery.setUTCDate(delivery.getUTCDate()+1);
 const days=['niedzielę','poniedziałek','wtorek','środę','czwartek','piątek','sobotę'];
 return {delivery:'Dostawa '+(delivery.getUTCDay()===2?'we ':'w ')+days[delivery.getUTCDay()],showTimer:today,seconds:Math.max(0,Math.ceil((deadline-now.getTime())/1000)),title:today?'Wysyłka jeszcze dziś':(Date.UTC(target.getUTCFullYear(),target.getUTCMonth(),target.getUTCDate())-Date.UTC(localDate.getUTCFullYear(),localDate.getUTCMonth(),localDate.getUTCDate())===86400000?'Wysyłka jutro':'Wysyłka '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]),label:today?'Zamów w ciągu:':'Zamów do 13:00 '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]+':'};
}

function initZP(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const shipping=root.querySelector('[data-zp-shipping]');
 if(shipping){
  const tick=()=>{const state=zpShippingState(new Date()),remaining=state.seconds;
   root.querySelector('[data-zp-dispatch-title]').textContent=state.title;
   root.querySelector('[data-zp-delivery-day]').textContent=state.delivery;
   root.querySelector('[data-zp-shipping-label]').textContent=state.label;
   root.querySelector('[data-zp-countdown]').textContent=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60].map(value=>String(value).padStart(2,'0')).join(':');
   shipping.hidden=!state.showTimer;
  };
  tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
 }
 root.querySelectorAll('[data-zp-quantity]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('input[name=quantity]');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(button.dataset.zpQuantity));}));
 const variant=root.querySelector('[data-zp-variant]');variant?.addEventListener('change',()=>{const option=variant.selectedOptions[0],available=option.dataset.available==='true';root.querySelector('[data-zp-price]').textContent=option.dataset.price;root.querySelector('[data-zp-add]').disabled=!available;root.querySelector('[data-zp-add-label]').textContent=available?'Dodaj do koszyka':'Wyprzedane';root.querySelector('[data-zp-stock]').textContent=available?'Dostępny':'Chwilowo niedostępny';});

}
document.querySelectorAll('[data-zero-product]').forEach(initZP);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-zero-product]').forEach(initZP));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-hero-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rc-hero-carousel')) {
  customElements.define('rc-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.userPaused = false;
      this.editorSelected = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(2000, Number(this.dataset.interval) || 5000);
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1, true), {signal});
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true), {signal});
      this.querySelector('[data-pause]')?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.updatePause();
        this.schedule();
      }, {signal});
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, {signal});
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
      this.addEventListener('focusout', e => { this.focused = this.contains(e.relatedTarget); this.schedule(); }, {signal});
      this.addEventListener('keydown', e => {
        if (e.target.matches('input,textarea,select,[contenteditable]')) return;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.show(this.index + (e.key === 'ArrowLeft' ? -1 : 1), true); }
      }, {signal});
      this.addEventListener('touchstart', e => { this.touch = e.changedTouches[0]; }, {signal, passive:true});
      this.addEventListener('touchend', e => {
        if (!this.touch) return;
        const x = e.changedTouches[0].clientX - this.touch.clientX;
        const y = e.changedTouches[0].clientY - this.touch.clientY;
        if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y)) this.show(this.index + (x < 0 ? 1 : -1), true);
        this.touch = null;
      }, {signal, passive:true});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', () => this.schedule(), {signal});
      document.addEventListener('shopify:block:select', e => {
        const index = this.slides.findIndex(s => s.dataset.blockId === e.detail?.blockId);
        if (index >= 0) { this.editorSelected = true; this.show(index); }
      }, {signal});
      document.addEventListener('shopify:block:deselect', e => {
        if (this.slides.some(s => s.dataset.blockId === e.detail?.blockId)) { this.editorSelected = false; this.schedule(); }
      }, {signal});
      this.show(0);
      this.updatePause();
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
    show(index, announce = false) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      if (announce) this.querySelector('[data-status]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.schedule();
    }
    updatePause() {
      const button = this.querySelector('[data-pause]');
      if (!button) return;
      button.setAttribute('aria-pressed', String(this.userPaused));
      button.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
      button.querySelector('span').textContent = this.userPaused ? '▶' : 'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.userPaused || this.hovered || this.focused || this.editorSelected || document.hidden || this.motion.matches) return;
      this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-inside"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rc-inside-slideshow')){
 customElements.define('rc-inside-slideshow',class extends HTMLElement{
 connectedCallback(){
  this.track=this.querySelector('.rc-inside-slides');this.slides=[...this.querySelectorAll('.rc-inside-slide')];this.index=0;
  if(this.slides.length<2)return;
  this.controls=this.querySelector('.rc-inside-controls');this.controls.hidden=false;
  this.play=this.querySelector('[data-play]');this.status=this.querySelector('[data-status]');
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');
  this.running=this.dataset.autoplay==='true'&&!this.motion.matches;
  this.abort=new AbortController();const opts={signal:this.abort.signal};
  this.querySelector('[data-prev]').addEventListener('click',()=>this.go(-1),opts);
  this.querySelector('[data-next]').addEventListener('click',()=>this.go(1),opts);
  this.play.addEventListener('click',()=>{this.running=!this.running;this.update();this.schedule()},opts);
  this.track.addEventListener('scroll',()=>{clearTimeout(this.scrollTimer);this.scrollTimer=setTimeout(()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.update();this.schedule()},120)},opts);
  this.addEventListener('pointerenter',()=>{this.hover=true;this.schedule()},opts);
  this.addEventListener('pointerleave',()=>{this.hover=false;this.schedule()},opts);
  this.addEventListener('pointerdown',()=>clearTimeout(this.timer),opts);
  this.addEventListener('pointerup',()=>this.schedule(),opts);
  this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},opts);
  this.addEventListener('focusout',()=>{this.focused=false;this.schedule()},opts);
  this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(e.key==='ArrowRight'?1:-1)}},opts);
  document.addEventListener('visibilitychange',()=>this.schedule(),opts);
  this.update();this.schedule();
 }
 go(delta){this.index=(this.index+delta+this.slides.length)%this.slides.length;this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:this.motion.matches?'instant':'smooth'});this.update();this.schedule()}
 update(){this.status.textContent=(this.index+1)+' / '+this.slides.length;this.play.textContent=this.running?'Ⅱ':'▶';this.play.setAttribute('aria-label',this.running?'Wstrzymaj pokaz':'Uruchom pokaz')}
 schedule(){clearTimeout(this.timer);if(this.running&&!this.hover&&!this.focused&&!document.hidden)this.timer=setTimeout(()=>this.go(1),Number(this.dataset.interval)||5000)}
 disconnectedCallback(){clearTimeout(this.timer);clearTimeout(this.scrollTimer);this.abort?.abort()}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-iskra-home"] && !Shopify.designMode) return;
  try {
    
function initRW(root) {
  if (!root || root.dataset.rwReady) return;
  root.dataset.rwReady = 'true';
  let category = 'all';
  const cards = Array.from(root.querySelectorAll('[data-rw-product]'));
  const grid = root.querySelector('[data-rw-grid]');
  const search = root.querySelector('[data-rw-search]');
  const sort = root.querySelector('[data-rw-sort]');
  const normalize = value => value.toLocaleLowerCase('pl').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l');
  const update = () => {
    let count = 0;
    cards.forEach(card => {
      const match = (category === 'all' || card.dataset.rwCategory === category) && normalize(card.dataset.rwTitle).includes(normalize(search.value.trim()));
      card.hidden = !match;
      if (match) count++;
    });
    const sorted = [...cards].sort((a,b) => sort.value === 'asc' ? Number(a.dataset.rwPrice)-Number(b.dataset.rwPrice) : sort.value === 'desc' ? Number(b.dataset.rwPrice)-Number(a.dataset.rwPrice) : Number(a.dataset.rwOrder)-Number(b.dataset.rwOrder));
    sorted.forEach(card => grid.appendChild(card));
    root.querySelector('[data-rw-count]').textContent = count + ' / ' + cards.length;
    root.querySelector('[data-rw-empty]').hidden = count !== 0;
  };
  root.querySelectorAll('[data-rw-filter]').forEach(button => button.addEventListener('click', () => {
    category = button.dataset.rwFilter;
    root.querySelectorAll('[data-rw-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    update();
  }));
  search.addEventListener('input', update);
  sort.addEventListener('change', update);
  update();
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('rw-seen'); observer.unobserve(entry.target); }
    }), {threshold:.08});
    root.querySelectorAll('.rw-reveal').forEach(item => observer.observe(item));
  }
}
document.querySelectorAll('[data-rw-home]').forEach(initRW);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rw-home]').forEach(initRW));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-rach-zero"]) return;
  try {
    
function rachShippingState(now){
 const zone=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 const localStamp=date=>{const p=Object.fromEntries(zone.formatToParts(date).filter(x=>x.type!=='literal').map(x=>[x.type,Number(x.value)]));return Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);};
 const local=localStamp(now),localDate=new Date(local),weekday=localDate.getUTCDay();
 const today=weekday>=1&&weekday<=5&&localDate.getUTCHours()<13;
 let target=new Date(local);target.setUTCHours(13,0,0,0);
 if(!today){target.setUTCDate(target.getUTCDate()+1);while(target.getUTCDay()===0||target.getUTCDay()===6)target.setUTCDate(target.getUTCDate()+1);}
 let deadline=target.getTime();for(let i=0;i<3;i++)deadline+=target.getTime()-localStamp(new Date(deadline));
 const delivery=new Date(target);delivery.setUTCDate(delivery.getUTCDate()+1);while(delivery.getUTCDay()===0||delivery.getUTCDay()===6)delivery.setUTCDate(delivery.getUTCDate()+1);
 const days=['niedzielę','poniedziałek','wtorek','środę','czwartek','piątek','sobotę'];
 return {delivery:'Dostawa '+(delivery.getUTCDay()===2?'we ':'w ')+days[delivery.getUTCDay()],showTimer:today,seconds:Math.max(0,Math.ceil((deadline-now.getTime())/1000)),title:today?'Wysyłka jeszcze dziś':(Date.UTC(target.getUTCFullYear(),target.getUTCMonth(),target.getUTCDate())-Date.UTC(localDate.getUTCFullYear(),localDate.getUTCMonth(),localDate.getUTCDate())===86400000?'Wysyłka jutro':'Wysyłka '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]),label:today?'Zamów w ciągu:':'Zamów do 13:00 '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]+':'};
}

function initRachPage(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const shipping=root.querySelector('[data-zp-shipping]');
 if(shipping){
  const tick=()=>{const state=rachShippingState(new Date()),remaining=state.seconds;
   root.querySelector('[data-zp-dispatch-title]').textContent=state.title;
   root.querySelector('[data-zp-delivery-day]').textContent=state.delivery;
   root.querySelector('[data-zp-shipping-label]').textContent=state.label;
   root.querySelector('[data-zp-countdown]').textContent=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60].map(value=>String(value).padStart(2,'0')).join(':');
   shipping.hidden=!state.showTimer;
  };
  tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
 }
 root.querySelectorAll('[data-zp-quantity]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('input[name=quantity]');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(button.dataset.zpQuantity));}));
 const variant=root.querySelector('[data-zp-variant]');variant?.addEventListener('change',()=>{const option=variant.selectedOptions[0],available=option.dataset.available==='true';root.querySelector('[data-zp-price]').textContent=option.dataset.price;root.querySelector('[data-zp-add]').disabled=!available;root.querySelector('[data-zp-add-label]').textContent=available?'Dodaj do koszyka':'Wyprzedane';root.querySelector('[data-zp-stock]').textContent=available?'Dostępny':'Chwilowo niedostępny';});

}
document.querySelectorAll('[data-rach-product]').forEach(initRachPage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-rach-product]').forEach(initRachPage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-science-collection"] && !Shopify.designMode) return;
  try {
    
function initSC(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const cards=[...root.querySelectorAll('[data-sc-product]')],search=root.querySelector('[data-sc-search]');let onlyAvailable=false;
 const normalize=value=>value.toLocaleLowerCase('pl').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ł/g,'l');
 const update=()=>{let visible=0;const query=normalize(search.value.trim());cards.forEach(card=>{card.hidden=(onlyAvailable&&card.dataset.scAvailable!=='true')||!normalize(card.dataset.scTitle).includes(query);if(!card.hidden)visible++;});root.querySelector('[data-sc-empty]').hidden=visible!==0||cards.length===0;root.querySelector('[data-sc-count]').textContent=cards.length?'Widoczne: '+visible+' / '+cards.length:'';};
 root.querySelectorAll('[data-sc-filter]').forEach(button=>button.addEventListener('click',()=>{onlyAvailable=button.dataset.scFilter==='available';root.querySelectorAll('[data-sc-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));update();}));
 search.addEventListener('input',update);update();
}
document.querySelectorAll('[data-sc-collection]').forEach(initSC);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sc-collection]').forEach(initSC));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-smart-collection"] && !Shopify.designMode) return;
  try {
    
function initSC(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const cards=[...root.querySelectorAll('[data-sc-product]')],search=root.querySelector('[data-sc-search]');let onlyAvailable=false;
 const normalize=value=>value.toLocaleLowerCase('pl').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ł/g,'l');
 const update=()=>{let visible=0;const query=normalize(search.value.trim());cards.forEach(card=>{card.hidden=(onlyAvailable&&card.dataset.scAvailable!=='true')||!normalize(card.dataset.scTitle).includes(query);if(!card.hidden)visible++;});root.querySelector('[data-sc-empty]').hidden=visible!==0||cards.length===0;root.querySelector('[data-sc-count]').textContent=cards.length?'Widoczne: '+visible+' / '+cards.length:'';};
 root.querySelectorAll('[data-sc-filter]').forEach(button=>button.addEventListener('click',()=>{onlyAvailable=button.dataset.scFilter==='available';root.querySelectorAll('[data-sc-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));update();}));
 search.addEventListener('input',update);update();
}
document.querySelectorAll('[data-sc-collection]').forEach(initSC);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sc-collection]').forEach(initSC));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-smart-kit"]) return;
  try {
    
function smartKitShippingState(now){
 const zone=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 const localStamp=date=>{const p=Object.fromEntries(zone.formatToParts(date).filter(x=>x.type!=='literal').map(x=>[x.type,Number(x.value)]));return Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);};
 const local=localStamp(now),localDate=new Date(local),weekday=localDate.getUTCDay();
 const today=weekday>=1&&weekday<=5&&localDate.getUTCHours()<13;
 let target=new Date(local);target.setUTCHours(13,0,0,0);
 if(!today){target.setUTCDate(target.getUTCDate()+1);while(target.getUTCDay()===0||target.getUTCDay()===6)target.setUTCDate(target.getUTCDate()+1);}
 let deadline=target.getTime();for(let i=0;i<3;i++)deadline+=target.getTime()-localStamp(new Date(deadline));
 const delivery=new Date(target);delivery.setUTCDate(delivery.getUTCDate()+1);while(delivery.getUTCDay()===0||delivery.getUTCDay()===6)delivery.setUTCDate(delivery.getUTCDate()+1);
 const days=['niedzielę','poniedziałek','wtorek','środę','czwartek','piątek','sobotę'];
 return {delivery:'Dostawa '+(delivery.getUTCDay()===2?'we ':'w ')+days[delivery.getUTCDay()],showTimer:today,seconds:Math.max(0,Math.ceil((deadline-now.getTime())/1000)),title:today?'Wysyłka jeszcze dziś':(Date.UTC(target.getUTCFullYear(),target.getUTCMonth(),target.getUTCDate())-Date.UTC(localDate.getUTCFullYear(),localDate.getUTCMonth(),localDate.getUTCDate())===86400000?'Wysyłka jutro':'Wysyłka '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]),label:today?'Zamów w ciągu:':'Zamów do 13:00 '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]+':'};
}

function initSmartKitPage(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const shipping=root.querySelector('[data-zp-shipping]');
 if(shipping){
  const tick=()=>{const state=smartKitShippingState(new Date()),remaining=state.seconds;
   root.querySelector('[data-zp-dispatch-title]').textContent=state.title;
   root.querySelector('[data-zp-delivery-day]').textContent=state.delivery;
   root.querySelector('[data-zp-shipping-label]').textContent=state.label;
   root.querySelector('[data-zp-countdown]').textContent=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60].map(value=>String(value).padStart(2,'0')).join(':');
   shipping.hidden=!state.showTimer;
  };
  tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
 }
 root.querySelectorAll('[data-zp-quantity]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('input[name=quantity]');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(button.dataset.zpQuantity));}));
 const variant=root.querySelector('[data-zp-variant]');variant?.addEventListener('change',()=>{const option=variant.selectedOptions[0],available=option.dataset.available==='true';root.querySelector('[data-zp-price]').textContent=option.dataset.price;root.querySelector('[data-zp-add]').disabled=!available;root.querySelector('[data-zp-add-label]').textContent=available?'Dodaj do koszyka':'Wyprzedane';root.querySelector('[data-zp-stock]').textContent=available?'Dostępny':'Chwilowo niedostępny';});

}
document.querySelectorAll('[data-smart-kit-product]').forEach(initSmartKitPage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-smart-kit-product]').forEach(initSmartKitPage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-smart-water"]) return;
  try {
    
function smartWaterShippingState(now){
 const zone=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Warsaw',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 const localStamp=date=>{const p=Object.fromEntries(zone.formatToParts(date).filter(x=>x.type!=='literal').map(x=>[x.type,Number(x.value)]));return Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);};
 const local=localStamp(now),localDate=new Date(local),weekday=localDate.getUTCDay();
 const today=weekday>=1&&weekday<=5&&localDate.getUTCHours()<13;
 let target=new Date(local);target.setUTCHours(13,0,0,0);
 if(!today){target.setUTCDate(target.getUTCDate()+1);while(target.getUTCDay()===0||target.getUTCDay()===6)target.setUTCDate(target.getUTCDate()+1);}
 let deadline=target.getTime();for(let i=0;i<3;i++)deadline+=target.getTime()-localStamp(new Date(deadline));
 const delivery=new Date(target);delivery.setUTCDate(delivery.getUTCDate()+1);while(delivery.getUTCDay()===0||delivery.getUTCDay()===6)delivery.setUTCDate(delivery.getUTCDate()+1);
 const days=['niedzielę','poniedziałek','wtorek','środę','czwartek','piątek','sobotę'];
 return {delivery:'Dostawa '+(delivery.getUTCDay()===2?'we ':'w ')+days[delivery.getUTCDay()],showTimer:today,seconds:Math.max(0,Math.ceil((deadline-now.getTime())/1000)),title:today?'Wysyłka jeszcze dziś':(Date.UTC(target.getUTCFullYear(),target.getUTCMonth(),target.getUTCDate())-Date.UTC(localDate.getUTCFullYear(),localDate.getUTCMonth(),localDate.getUTCDate())===86400000?'Wysyłka jutro':'Wysyłka '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]),label:today?'Zamów w ciągu:':'Zamów do 13:00 '+(target.getUTCDay()===2?'we ':'w ')+days[target.getUTCDay()]+':'};
}

function initSmartWaterPage(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const shipping=root.querySelector('[data-zp-shipping]');
 if(shipping){
  const tick=()=>{const state=smartWaterShippingState(new Date()),remaining=state.seconds;
   root.querySelector('[data-zp-dispatch-title]').textContent=state.title;
   root.querySelector('[data-zp-delivery-day]').textContent=state.delivery;
   root.querySelector('[data-zp-shipping-label]').textContent=state.label;
   root.querySelector('[data-zp-countdown]').textContent=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60].map(value=>String(value).padStart(2,'0')).join(':');
   shipping.hidden=!state.showTimer;
  };
  tick();const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}tick();},1000);
 }
 root.querySelectorAll('[data-zp-quantity]').forEach(button=>button.addEventListener('click',()=>{const input=root.querySelector('input[name=quantity]');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(button.dataset.zpQuantity));}));
 const variant=root.querySelector('[data-zp-variant]');variant?.addEventListener('change',()=>{const option=variant.selectedOptions[0],available=option.dataset.available==='true';root.querySelector('[data-zp-price]').textContent=option.dataset.price;root.querySelector('[data-zp-add]').disabled=!available;root.querySelector('[data-zp-add-label]').textContent=available?'Dodaj do koszyka':'Wyprzedane';root.querySelector('[data-zp-stock]').textContent=available?'Dostępny':'Chwilowo niedostępny';});

}
document.querySelectorAll('[data-smart-water-product]').forEach(initSmartWaterPage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-smart-water-product]').forEach(initSmartWaterPage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-wonder-home"] && !Shopify.designMode) return;
  try {
    
function initRW(root) {
  if (!root || root.dataset.rwReady) return;
  root.dataset.rwReady = 'true';
  let category = 'all';
  const cards = Array.from(root.querySelectorAll('[data-rw-product]'));
  const grid = root.querySelector('[data-rw-grid]');
  const search = root.querySelector('[data-rw-search]');
  const sort = root.querySelector('[data-rw-sort]');
  const normalize = value => value.toLocaleLowerCase('pl').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l');
  const update = () => {
    let count = 0;
    cards.forEach(card => {
      const match = (category === 'all' || card.dataset.rwCategory === category) && normalize(card.dataset.rwTitle).includes(normalize(search.value.trim()));
      card.hidden = !match;
      if (match) count++;
    });
    const sorted = [...cards].sort((a,b) => sort.value === 'asc' ? Number(a.dataset.rwPrice)-Number(b.dataset.rwPrice) : sort.value === 'desc' ? Number(b.dataset.rwPrice)-Number(a.dataset.rwPrice) : Number(a.dataset.rwOrder)-Number(b.dataset.rwOrder));
    sorted.forEach(card => grid.appendChild(card));
    root.querySelector('[data-rw-count]').textContent = count + ' / ' + cards.length;
    root.querySelector('[data-rw-empty]').hidden = count !== 0;
  };
  root.querySelectorAll('[data-rw-filter]').forEach(button => button.addEventListener('click', () => {
    category = button.dataset.rwFilter;
    root.querySelectorAll('[data-rw-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    update();
  }));
  search.addEventListener('input', update);
  sort.addEventListener('change', update);
  update();
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('rw-seen'); observer.unobserve(entry.target); }
    }), {threshold:.08});
    root.querySelectorAll('.rw-reveal').forEach(item => observer.observe(item));
  }
}
document.querySelectorAll('[data-rw-home]').forEach(initRW);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rw-home]').forEach(initRW));

  } catch(e) { console.error(e); }
})();
})();
